import { PageContext, getPageContext } from "./page-context";

interface BrowserContext {
  referer: string,
  location: string,
  userAgent: string,
  platform: string,
  language: string,
  languages: readonly string[];
  // https://segment.com/docs/connections/spec/page/ 
  // we really required PageProperty? it looks redundant! 
  // maybe this are present in the payload of the old request because
  // this properties was send automatically by every analytics.js request !?(follow link)  
  page: PageContext
}

/**
* Get the Browser Context data
*
* @return {BrowserContext}
*/
export function getBrowserContext(): BrowserContext {
  return {  
    referer: document.referrer,
    location: document.location.href,  
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    languages: navigator.languages,
    page: getPageContext()
  };
}
